var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "k-banner" }, [
    _c("picture", { staticClass: "content" }, [
      _c("source", {
        attrs: { srcset: _vm.banner.image, media: "(min-width: 769px)" }
      }),
      _vm._v(" "),
      _c("img", {
        ref: "image",
        staticClass: "image",
        attrs: { src: _vm.banner.image_secondary, alt: _vm.banner.name }
      })
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "overlay" })
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ad3fe9d4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ad3fe9d4","hasScoped":true,"transformToRequire":{"img":"src","image":"xlink:href","cimage":"placeholder","c-image":"placeholder","CImage":"placeholder"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/kaledo-components/src/components/KBanner.vue
// module id = 2031
// module chunks = 1610